(function() {
  var $c2cab42d284f9a2a$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("quantity-selector")) customElements.define("quantity-selector", class QuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('[type="number"]');
        this.minusButton = this.querySelector('button[name="minus"]');
        this.plusButton = this.querySelector('button[name="plus"]');
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.updateButtonStates = this.updateButtonStates.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }
      connectedCallback() {
        if (!this.input) return;
        this.productForm = this.closest("product-form");
        this.addEventListener("click", this.handleButtonClick);
        this.productForm?.addEventListener("variant:change", this.handleVariantChange);
        [ "input", "change" ].forEach(evt => this.input.addEventListener(evt, this.updateButtonStates));
        this.updateButtonStates();
      }
      disconnectedCallback() {
        if (!this.input) return;
        this.removeEventListener("click", this.handleButtonClick);
        this.productForm?.removeEventListener("variant:change", this.handleVariantChange);
        [ "input", "change" ].forEach(evt => this.input.removeEventListener(evt, this.updateButtonStates));
      }
      handleVariantChange(event) {
        const variant = event.detail?.variant;
        if (!variant || !this.input) return;
        const min = Number(this.input.dataset.min || this.input.min || 1);
        const maxFromVariant = Number(variant?.quantity_rule?.max) || Number(this.input.dataset.max) || 99;
        const isAvailable = !!variant.available;
        let currentMax = maxFromVariant;
        if (variant.inventory_management === "shopify" && variant.inventory_policy === "deny" && Number.isFinite(Number(variant.inventory_quantity))) currentMax = Math.min(Math.max(0, Number(variant.inventory_quantity)), maxFromVariant);
        this.input.min = String(min);
        this.input.max = String(currentMax);
        const value = Number(this.input.value) || min;
        this.input.value = String(Math.min(Math.max(value, min), currentMax || min));
        const isPurchasable = isAvailable && currentMax > 0;
        this.setAttribute("aria-hidden", String(!isPurchasable));
        if (isPurchasable) {
          this.input.removeAttribute("disabled");
          this.input.setAttribute("aria-disabled", "false");
          this.setAttribute("aria-disabled", "false");
        } else {
          this.input.setAttribute("disabled", "disabled");
          this.input.setAttribute("aria-disabled", "true");
          this.setAttribute("aria-disabled", "true");
        }
        this.updateButtonStates();
      }
      handleButtonClick(event) {
        const button = event.target.closest("button");
        if (!button || button.name !== "plus" && button.name !== "minus") return;
        event.preventDefault();
        if (button.disabled || button.getAttribute("aria-disabled") === "true") return;
        const previousValue = this.input.value;
        if (button.name === "plus") this.input.stepUp(); else if (button.name === "minus") this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
      updateButtonStates() {
        if (!this.input) return;
        const isDisabled = this.input.disabled || this.getAttribute("aria-disabled") === "true";
        if (isDisabled) {
          if (this.minusButton) this.toggleButtonState(this.minusButton, true);
          if (this.plusButton) this.toggleButtonState(this.plusButton, true);
          return;
        }
        const value = Number(this.input.value);
        const min = Number(this.input.min) || 1;
        const max = Number(this.input.max) || Infinity;
        if (this.minusButton) this.toggleButtonState(this.minusButton, value <= min);
        if (this.plusButton) this.toggleButtonState(this.plusButton, value >= max);
      }
      toggleButtonState(button, isDisabled) {
        if (isDisabled) {
          button.setAttribute("disabled", "disabled");
          button.setAttribute("aria-disabled", "true");
        } else {
          button.removeAttribute("disabled");
          button.setAttribute("aria-disabled", "false");
        }
      }
    });
  })();
})();